import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSword: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSword"><Path d="M13.4764 3L8.20312 10.617L13.3834 15.7972L21.0004 10.524V3H13.4764Z" fill="currentColor"/><Path d="M4.84473 9.43042L2.78524 12.5196L5.19404 15.892L1.58594 19.5001L4.50015 22.4143L8.10825 18.8062L11.4806 21.215L14.5698 19.1555L4.84473 9.43042Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSword;
